import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { capitalise } from 'src/helpers/capitalise';

type TBreadcrumbs = {
  label: string;
  path: string;
}[];

const useBreadcrumbs = () => {
  const { pathname } = useLocation();

  // Sets the label to be displayed in the header for the chosen path
  const getLabel = (path: string, label: string) => {
    if (path === '/items') return 'Product Library';
    return label;
  };

  const breadcrumbs = useMemo<TBreadcrumbs>(() => {
    const pathnames = pathname.split('/').filter((x) => x);
    return pathnames.map((value, index) => {
      const path = `/${pathnames.slice(0, index + 1).join('/')}`;
      return { label: getLabel(path, capitalise(value)), path };
    });
  }, [pathname]);

  return breadcrumbs;
};

export default useBreadcrumbs;
